/**
 * displayJson
 *
 * Similar to JSON.stringify(object, null, 2),
 * but stops after "levels" levels (should be an integer)
 *
 * @param {object} obj              Object to display
 * @param {number} levels           Number of levels to display
 * @param {string} thisStepIndent   Recursive call info, leave blank
 * @param {string} prefix           Recursive call info, leave blank
 * @returns
 */
const displayJson = (obj, levels = 10, indent = undefined, prefix = '') => {
  const thisStepIndent = (indent === undefined) ? '' : `${indent}  `;
  let result = '';
  if (typeof obj === 'function') {
    const name = obj.name || 'unknown';
    result += (`${thisStepIndent + prefix}--function ${name}--`);
  } else if ((typeof obj?.getMonth === 'function') && (obj instanceof Date)) {
    const year = obj.getUTCFullYear().toString();
    const month = (obj.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = obj.getUTCDate().toString().padStart(2, '0');
    const hours = obj.getUTCHours().toString().padStart(2, '0');
    const minutes = obj.getUTCMinutes().toString().padStart(2, '0');
    const seconds = obj.getUTCSeconds().toString().padStart(2, '0');
    const milliseconds = obj.getUTCMilliseconds().toString().padStart(3, '0');

    result += (`${thisStepIndent + prefix}${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}`);
  } else if ((!obj) || (!levels)) {
    // Nothing to display, or last level to display
    //
    if (Array.isArray(obj)) {
      if (obj.length) result += (`${thisStepIndent + prefix}[ array, ${obj.length} items ]`);
      else result += (`${thisStepIndent + prefix}[]`);
    } else if (obj instanceof Set) {
      result += (`${thisStepIndent + prefix}Set[${obj.size} items]`);
    } else if (obj instanceof Map) {
      result += (`${thisStepIndent + prefix}Map[${obj.size} items]`);
    } else if ((obj === null) || (obj === undefined)) {
      result += (thisStepIndent + prefix + obj);
    } else if (typeof obj === 'object') {
      if (Object.keys(obj).length) result += (`${thisStepIndent + prefix}object`);
      else result += (`${thisStepIndent + prefix}{}`);
    } else if (typeof obj === 'string') {
      result += (`${thisStepIndent + prefix}${obj}`);
    } else {
      result += (thisStepIndent + prefix + obj.toString());
    }
  } else if (Array.isArray(obj)) {
    if (!obj.length) result += (`${thisStepIndent}${prefix}[]`);
    else {
      result += (`${thisStepIndent}${prefix}[\n`);
      obj.forEach((value, index) => {
        const separator = (index === (obj.length - 1)) ? '' : ',';
        result += `${displayJson(value, levels - 1, thisStepIndent)}${separator}\n`;
      });
      result += (`${thisStepIndent}]`);
    }
  } else if (obj instanceof Set) {
    if (!obj.size) result += (`${thisStepIndent}${prefix}Set[]`);
    else {
      result += (`${thisStepIndent}${prefix}Set[\n`);
      obj.forEach((value, index) => {
        const separator = (index === (obj.size - 1)) ? '' : ',';
        result += `${displayJson(value, levels - 1, thisStepIndent)}${separator}\n`;
      });
      result += (`${thisStepIndent}]`);
    }
  } else if (obj instanceof Map) {
    if (!obj.size) result += (`${thisStepIndent}${prefix}Map[]`);
    else {
      let index = 0;
      result += (`${thisStepIndent}${prefix}Map[\n`);
      obj.forEach((value, key) => {
        const separator = (index === (obj.size - 1)) ? '' : ',';
        result += `${displayJson(value, levels - 1, thisStepIndent, `"${key}": `)}${separator}\n`;
        index += 1;
      });
      result += (`${thisStepIndent}]`);
    }
  } else if ((typeof obj === 'object') && (obj !== null)) {
    if (!Object.keys(obj).length) result += (`${thisStepIndent}${prefix}{}`);
    else {
      result += (`${thisStepIndent}${prefix}{\n`);
      const keys = Object.keys(obj);
      keys.forEach((key, index) => {
        const separator = (index === (keys.length - 1)) ? '' : ',';
        result += `${displayJson(obj[key], levels - 1, thisStepIndent, `"${key}": `)}${separator}\n`;
      });
      result += (`${thisStepIndent}}`);
    }
  } else if (typeof obj === 'string') {
    result += (`${thisStepIndent + prefix}"${obj}"`);
  } else {
    result += (thisStepIndent + prefix + obj.toString());
  }
  return result;
};

export default displayJson;
